<!--
    @component steelTradeAggrid 钢贸aggrid表格组件
    @props
        {Array} columnDefs - 主表列配置  []
        {Array} rowData - 表格数据 []
        {String} tableSelection 选择模式 null
        {Boolean} autoLoadData 表格加载完成第一次自动加载数据
        {String} rowKey 行唯一键值(例如sId) 必填
        {Boolean} isSubtable 是否主子表 false
        {Array} childColumnDefs 子表列配置 []
        {String} childrenListKey 子表数据存在的key '_details'
        {String} childRowKey 子表键值 若拥有子表必填 ''
        {Boolean} childAllSelect 子表是否可以全选
        {Function} loadDetail 懒加载子表方法 需要返回promise {}
        {Array} headerTotal 头部合计数组 具体参考本文件夹gridTotal的countList参数
        {Array} footerTotal 底部合计数组 具体参考本文件夹gridTotal的countList参数
        {Funciton} handleDetailCount 子表合计方法 入参{detail object}详情对象 需要返回 Array
          [{ count: 1,key:'count' },
          { title: '已到票未到货数量', count: 3, unit: '吨' },
          { title: '金额', count: 3, unit: '元' }]
        {String} fullRowType 全行编辑配置 null 可配置all parent child
    @events
        {Object} rowClicked 主表点击行回调
            @param {Object} 行以及aggrid源生返回数据
        {Object} rowDoubleClicked 主表双击行回调
            @param {Object} 行以及aggrid源生返回数据
        {Object} childRowClicked 子表点击行回调
            @param {Object} 行以及aggrid源生返回数据
        {Object} childRowDoubleClicked 子表双击行回调
            @param {Object} 行以及aggrid源生返回数据
        {Object} selectedChange rowData watch
            @param {Array} 选中数据
    @methods
        {Function} clearSelection 清空选中
        {Function} refreshTable 刷新表格
        {Function} pageChange 调用传入{page: 0, limit: 20}即初始化分页重新获取
        {Function} getSelectedData 调用返回表格选中数据 若传入margeChild则返回所选所有子级的合集
        {Function} stopChildEditing 取消所有子表编辑状态
    @author 青木/KYUUTA
    @date 2020-12-15 11:00:25
    @update 2021-02-01 17:07:20
-->
<template>
  <ag-grid-wrap
    v-if="gridShow"
    ref="stGrid"
    class="steel-trade-aggrid"
    :style="gridStyle"
  >
    <div
      v-if="rowData.length > 0 && ($slots.header || headerTotal)"
      class="steel-trade-aggrid-row steel-trade-aggrid-header"
    >
      <slot v-if="$slots.header" name="header" />
      <gridTotal v-else flag="header" :count-list="headerTotal" />
    </div>
    <ag-grid-vue
      :class="[
        'table',
        'ag-theme-balham',
        'grid-class',
        'master-detail',
        scrollStyle,
        initClass1,
        initClass2
      ]"
      :style="`height: 100%;${initStyle1};${initStyle2}`"
      :grid-options="gridOptions"
      :column-defs="gridColumnDefs"
      :row-data="rowData"
      :modules="AllModules"
      :detail-row-auto-height="isSubtable"
      :apply-column-def-order="applyColumnDefOrder"
      v-bind="$attrs"
      @grid-ready="onGridReady"
      @selection-changed="handlSelectionChange"
    />
    <local-pagination
      v-if="paginationinif"
      :total="pagination.total"
      :page="pagination.page"
      :limit="pagination.limit"
      :event="pageChange"
    >
      <template slot="pagination-left">
        <div
          v-if="$slots.footer || footerTotal"
          class="steel-trade-aggrid-row steel-trade-aggrid-footer"
        >
          <slot v-if="$slots.footer" name="footer" />
          <gridTotal v-else flag="footer" :count-list="footerTotal" />
        </div>
      </template>
    </local-pagination>
  </ag-grid-wrap>
</template>

<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import { AllModules } from 'ag-grid-enterprise'
import { AG_GRID_LOCALE_CN } from '../../../../lib/lang/ag-grid.zh.js'
import childHeaderSelect from '../../AgGridExtend/childHeaderSelect'
import childSelect from '../../AgGridExtend/childSelect'
import headerSelect from '../../AgGridExtend/headerSelect'
import parentSelect from '../../AgGridExtend/parentSelect'
import headerDefSelect from '../../AgGridExtend/headerDefSelect'
import defSelect from '../../AgGridExtend/defSelect'
import TableInput from './TableInput.vue'
import imageViewer from './imageViewer.vue'
import gridTotal from './gridTotal'
import localPagination from '../../Pagination/index.js'

import { handleGridColumnDefs, handleGridChildColumnDefs } from './columnDefs'

import { deepClone } from './utils.js'

import '../../../../lib/styles/components/CommonAgGrid.scss'
export default {
  name: 'CommonAgGrid',
  components: { AgGridVue, gridTotal, imageViewer, localPagination },
  props: {
    // 是否需要分页
    paginationinif: {
      type: Boolean,
      default: true
    },
    // 默认页数
    defaultPage: {
      type: [Number, String],
      default: 0
    },
    // 默认页码
    defaultPageSize: {
      type: [Number, String],
      default: 30
    },
    // heightinif 表格高度
    heightinif: {
      type: [Number, String],
      default: 0
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    // autoHeight为true时，minHeight生效
    minHeight: {
      type: [Number, String],
      default: 100
    },
    // 主标列配置
    columnDefs: {
      type: Array,
      default: () => []
    },
    frameworkComponents: {
      type: Object,
      default: () => {}
    },
    // 表格数据
    rowData: {
      type: Array,
      default: () => []
    },
    // 选择模式
    tableSelection: {
      type: String,
      default: null,
      validator: function(value) {
        return ['single', 'multiple', null].indexOf(value) !== -1
      }
    },
    // 自适应
    isSizeColumnsToFit: {
      type: Boolean,
      default: false
    },
    // 自动加载数据
    autoLoadData: {
      type: Boolean,
      default: true
    },
    // 行唯一键值
    rowKey: {
      type: String,
      required: true
    },
    // 加载事件用于翻页
    loadData: {
      type: Function,
      default: null
    },
    // 是否主子表
    isSubtable: {
      type: Boolean,
      default: false
    },
    // 子表列配置
    childColumnDefs: {
      type: Array,
      default: () => []
    },
    // 子表数据存放属性
    childrenListKey: {
      type: String,
      default: '_details'
    },
    // 子表键值
    childRowKey: {
      type: String,
      default: ''
    },
    // 子表是否可以全选
    childAllSelect: {
      type: Boolean,
      default: false
    },
    // 懒加载子表方法
    loadDetail: {
      type: Function,
      default: null
    },
    handleDetailCount: {
      type: [Function, Object],
      default: null
    },
    // 头部合计
    headerTotal: {
      type: Array,
      default: null
    },
    // 底部合计
    footerTotal: {
      type: Array,
      default: null
    },
    // 是否全行编辑 all parent child
    fullRowType: {
      type: String,
      default: null
    },
    // 是否禁用黏贴 all parent child
    disablePaste: {
      type: String,
      default: null
    },
    // 重新设置表头 恢复排序
    applyColumnDefOrder: {
      type: Boolean,
      default: true
    },
    additionalOptions: {
      type: Object,
      default: () => {}
    },
    detailOptions: {
      type: Object,
      default: () => {}
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    isAutoSizeColumns: {
      type: Boolean,
      default: false
    },
    isAutoSizeColumnsHeader: {
      type: Boolean,
      default: false
    },
    enableZeroValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      initClass1: '',
      initClass2: '',
      initStyle1: '',
      initStyle2: '',
      AllModules,
      gridShow: true,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      gridColumnDefs: [],
      gridChildColumnDefs: [],
      childColumnDefs_: [],
      columnWidth: 0,
      gridHeight: 0,
      pagination: {
        total: 0,
        page: 0,
        limit: 30
      },
      onHeaderDefSelect: (selected) => {
        this.$emit('headerSelected', selected)
      },
      onDefSelect: (params, selected) => {
        this.$emit('rowSelected', params, selected)
      }
    }
  },
  computed: {
    gridStyle() {
      const style = {}
      const gridHeight = +this.gridHeight
      if (gridHeight > 0) {
        style.height = `${gridHeight}px`
      }
      return style
    },
    scrollStyle() {
      const userAgent = navigator.userAgent.toLowerCase()
      const preg = new RegExp('windows|win32|win64|wow32|wow64', 'g')
      return preg.test(userAgent) ? 'scroll-style' : ''
    }
  },
  watch: {
    fullRowType(newVal, oldVal) {
      this.gridShow = false
      this.initGridOptions()
      this.$nextTick(() => {
        this.gridShow = true
      })
    },
    rowData: {
      deep: true,
      handler(newValue, oldValue) {
        if (this.gridApi) {
          this.$nextTick(() => {
            this.gridApi.forEachNode((v) => {
              const _selectedKeys = v.data._selectedKeys || []
              const _selected = v.data._selected || _selectedKeys.length > 0
              v.selected = !_selected
              v.setSelected(_selected, true, true)
              if (v.detailNode && v.detailNode.detailGridInfo) {
                v.detailNode.detailGridInfo.api.forEachNode((o) => {
                  const oState =
                    _selectedKeys.indexOf(o.data[this.childRowKey]) !== -1
                  o.selected = !oState
                  o.setSelected(oState, true, true)
                })
              }
            })
          })
        }
        this.$emit('selectedChange', newValue)
        if (newValue.length <= 1) {
          this.handleGridHeight(newValue.length)
        }
        this.handlePinnedBottomRowData(newValue)
      }
    }
  },
  created() {
    this.pagination.page = this.defaultPage
    this.pagination.limit = this.defaultPageSize
    this.gridChildColumnDefs = this.childColumnDefs
    if (!this.autoHeight) {
      this.gridHeight = this.heightinif
    }
    const initClass1 = localStorage.getItem('spaceClass')
    const initClass2 = localStorage.getItem('themeClass')
    const initStyle1 = localStorage.getItem('agColorStyle')
    const initStyle2 = localStorage.getItem('agSpaceStyle')
    this.initClass1 = initClass1 != null ? initClass1 : 'spacing-default'
    this.initClass2 = initClass2 != null ? initClass2 : 'spacing-default'
    this.initStyle1 = initStyle1 != null ? initStyle1 : ''
    this.initStyle2 = initStyle2 != null ? initStyle2 : ''
    this.initGridOptions()
  },
  methods: {
    initGridOptions() {
      let columnCount = 0
      let fillWidth = 0
      let _fill = 0
      const _this = this
      const fullRowType = this.fullRowType
      const hasSecMeter = this.columnDefs.some((item) => item.children)
      const disablePaste = this.disablePaste
      const gridOptions = {
        suppressClipboardPaste: !!(
          disablePaste === 'all' || disablePaste === 'parent'
        ),
        embedFullWidthRows: true,
        frameworkComponents: {
          TableInput: Vue.extend(TableInput),
          headerSelect: Vue.extend(headerSelect),
          parentSelect: Vue.extend(parentSelect),
          headerDefSelect: Vue.extend(headerDefSelect),
          defSelect: Vue.extend(defSelect),
          imageViewer: Vue.extend(imageViewer),
          ...this.frameworkComponents
        },
        context: {
          componentParent: this,
          rowKey: this.rowKey,
          childRowKey: this.childRowKey,
          childrenListKey: this.childrenListKey,
          tableSelection: this.tableSelection,
          onHeaderDefSelect: this.onHeaderDefSelect,
          onDefSelect: this.onDefSelect,
          loadDetail: this.loadDetail,
          enableZeroValue: this.enableZeroValue
        },
        rowHeight: 36,
        headerHeight: 32,
        defaultColDef: {
          cellStyle: {
            'line-height': '36px'
          },
          filter: true,
          sortable: true,
          resizable: true
        },
        editType:
          fullRowType === 'all' || fullRowType === 'parent' ? 'fullRow' : null,
        overlayLoadingTemplate: `<span class="ag-overlay-loading-center">${this.$t(
          'grid.others.dataLoading'
        )}...</span>`,
        overlayNoRowsTemplate: `<span><span>`,
        localeText: AG_GRID_LOCALE_CN,
        rowSelection: this.tableSelection,
        suppressRowClickSelection: true,
        enableRangeSelection: true,
        masterDetail: this.isSubtable,
        //* *************设置固定行样式**********
        // 公共样式已统一配置
        // getRowStyle: (params) => {
        //   if (params.node.rowPinned) {
        //     return { 'color': '#3e8ddc', 'border-top': '2px solid #3e8ddc !important', 'font-weight': '600', 'border-bottom': '0' }
        //   }
        // },
        isRowMaster: (dataItem) => {
          const hasLoadDetail = typeof this.loadDetail === 'function'
          return (
            (this.isSubtable &&
              dataItem[this.childrenListKey] &&
              dataItem[this.childrenListKey].length) ||
            hasLoadDetail
          )
        },
        onRowClicked: (params) => {
          this.stopChildEditing()
          this.$emit('rowClicked', params)
        },
        onRowDoubleClicked: (params) => {
          const path = params.event.path || []
          const el = path.length ? path[0] : null
          if (el && el.className.includes('ag-icon')) {
            return
          }
          this.$emit('rowDoubleClicked', params)
        },
        onCellValueChanged: (params) => {
          this.refreshTable()
          this.$emit('cellValueChanged', params)
        },
        onCellEditingStopped: (params) => {
          this.$emit('cellEditingStopped', params)
        },
        onRowValueChanged: (params) => {
          this.$emit('rowValueChanged', params)
        },
        onRowGroupOpened: (params) => {
          params.expanded ? columnCount++ : columnCount--
          if (_fill === 0) {
            fillWidth =
              params.columnApi.getColumnState()[
                params.columnApi.getColumnState().length - 1
              ].width
            _fill = 1
          }
          columnCount === 0 &&
            gridOptions.columnApi.setColumnWidth('fill', fillWidth, true)
          this.$emit('rowGroupOpened', params)
        },
        onColumnResized: (params) => {
          if (params.source === 'uiColumnDragged' && params.finished) {
            gridOptions.api.forEachNode((node) => {
              const detailNode = node.detailNode
              detailNode &&
                detailNode.detailGridInfo &&
                detailNode.detailGridInfo.api.sizeColumnsToFit()
              if (detailNode && detailNode.detailGridInfo) {
                detailNode.detailGridInfo.columnApi
                  .getColumnState()
                  .filter((item, index) => {
                    _this.gridChildColumnDefs[index].width = item.width
                  })
              }
            })
          }
        },
        ...this.additionalOptions
      }
      this.gridColumnDefs = handleGridColumnDefs(
        this.isSubtable,
        hasSecMeter,
        this.tableSelection,
        this.columnDefs,
        this.childAllSelect
      )
      if (this.isSubtable) {
        gridOptions.masterDetail = true
        // 子表配置
        gridOptions.detailCellRendererParams = {
          detailGridOptions: {
            suppressClipboardPaste: !!(
              disablePaste === 'all' || disablePaste === 'child'
            ),
            suppressHorizontalScroll: false,
            frameworkComponents: {
              childHeaderSelect: Vue.extend(childHeaderSelect),
              TableInput: Vue.extend(TableInput),
              childSelect: Vue.extend(childSelect),
              imageViewer: Vue.extend(imageViewer),
              ..._this.frameworkComponents
            },
            columnDefs: handleGridChildColumnDefs(
              hasSecMeter,
              this.tableSelection,
              this.gridChildColumnDefs,
              this.childAllSelect
            ),
            context: gridOptions.context,
            rowHeight: 36,
            headerHeight: 33,
            defaultColDef: {
              cellStyle: {
                'line-height': '36px'
              },
              filter: true,
              sortable: true,
              resizable: true,
              suppressMenu: true // 子表不显示头部菜单
            },
            editType:
              fullRowType === 'all' || fullRowType === 'child'
                ? 'fullRow'
                : null,
            overlayLoadingTemplate: `<span class="ag-overlay-loading-center">${this.$t(
              'grid.others.dataLoading'
            )}...</span>`,
            overlayNoRowsTemplate: `<span class="ag-overlay-loading-center">${this.$t(
              'grid.others.noData'
            )}<span>`,
            localeText: AG_GRID_LOCALE_CN,
            rowSelection: 'multiple',
            suppressRowClickSelection: true,
            enableRangeSelection: true,
            onRowClicked: (params) => {
              this.$emit('childRowClicked', params)
            },
            onRowDoubleClicked: (params) => {
              this.$emit('childRowDoubleClicked', params)
            },

            onCellEditingStarted: (params) => {
              // 清空其他子级编辑 全行编辑 不执行
              if (!(fullRowType === 'all' || fullRowType === 'child')) {
                _this.stopChildEditing(params.data.parentId)
              }
            },
            onCellEditingStopped: (params) => {
              this.$emit('childCellEditingStopped', params)
            },
            onCellValueChanged: (params) => {
              this.refreshTable()
              this.$emit('childCellValueChanged', params)
            },
            onRowEditingStarted: (params) => {
              // 清空其他子级编辑
              _this.stopChildEditing(params.data.parentId)
            },
            onRowValueChanged: (params) => {
              this.$emit('childRowValueChanged', params)
            },

            onGridReady: function(params) {
              if (this.isSizeColumnsToFit) {
                params.columnApi.sizeColumnsToFit()
              } else {
                columnCount === 1 &&
                  setTimeout(() => {
                    _this.columnWidth =
                      fillWidth +
                      params.columnApi.columnModel.bodyWidth -
                      params.columnApi.columnModel.scrollWidth

                    gridOptions.columnApi.setColumnWidth(
                      'fill',
                      _this.columnWidth,
                      true
                    )
                    params.columnApi.getColumnState().filter((item, index) => {
                      _this.gridChildColumnDefs[index] &&
                        (_this.gridChildColumnDefs[index].width =
                          params.columnApi.getColumnState()[index + 1].width)
                    })
                  }, 300)
              }
              _this.$emit('childReady')
            },
            onColumnResized: function(params) {
              if (params.source === 'uiColumnDragged' && params.finished) {
                _this.columnWidth =
                  _this.columnWidth +
                  params.columnApi.columnController.bodyWidth -
                  params.columnApi.columnController.scrollWidth
                gridOptions.columnApi.setColumnWidth(
                  'fill',
                  _this.columnWidth,
                  true
                )
                gridOptions.api.forEachNode((node) => {
                  const detailNode = node.detailNode
                  detailNode &&
                    detailNode.detailGridInfo &&
                    detailNode.detailGridInfo.columnApi.setColumnWidth(
                      params.columns[0].colId,
                      params.columns[0].actualWidth,
                      true
                    )
                })
                _this.childColumnDefs_.filter((item, index) => {
                  if (item.field === params.columns[0].colId) {
                    _this.childColumnDefs_[index].width =
                      params.columns[0].actualWidth
                  }
                })
              }
            },
            ...this.detailOptions
          },
          getDetailRowData: async(params) => {
            const { childrenListKey, childRowKey } = this

            if (typeof this.loadDetail === 'function') {
              params.data[childrenListKey] = await this.loadDetail(params.data)
            }

            if (params.data[childrenListKey]) {
              const callRecords = params.data[childrenListKey].map((item) => {
                return {
                  ...item,
                  parentId: params.node.parent.id
                }
              })
              if (params.data._selected) {
                params.data._selectedKeys = params.data[childrenListKey].map(
                  (item) => {
                    if (!item._selectedDisabled) {
                      return item[childRowKey]
                    }
                  }
                )
              }
              new Promise((r) => {
                params.successCallback(callRecords)
                r(callRecords)
              }).then(() => {
                if (this.gridOptions.embedFullWidthRows) {
                  this.handleDetailRow(
                    params,
                    callRecords,
                    params.data._selectedKeys.length === callRecords.length
                  )
                }
              })
            } else {
              params.successCallback([])
            }
          }
        }
      }
      this.gridOptions = gridOptions
    },
    handleDetailRow(params, callRecords, isSelectAll) {
      if (!callRecords.length) return
      const cLength = callRecords.length
      const parentRowIndex = params.node.parent.id
      this.$nextTick(() => {
        const queryNode = '.ag-pinned-left-cols-container .ag-details-row'
        const detail_row = document.querySelectorAll(queryNode)
        if (!detail_row.length) return
        let el = null
        Array.from(detail_row).forEach((item) => {
          const row_id = item.parentElement.attributes['row-id'].value
          const parentId = `detail_${parentRowIndex}`
          el = row_id === parentId ? item : null
        })
        if (!el) return
        this.insertDom(el, cLength, isSelectAll)
      })
    },
    insertDom(el, cLength, isSelectAll) {
      const commonClass = [
        'ag-row-no-focus',
        'ag-row',
        'ag-row-level-1',
        'ag-row-position-absolute',
        'ag-row-first',
        'customer-dom'
      ]
      isSelectAll
        ? commonClass.push(...['ag-row-focus', 'ag-row-selected'])
        : null
      const createChildRowElement = (evenOdd, commonClass, style) => {
        const div = document.createElement('div')
        div.classList.add(...[...commonClass, evenOdd])
        div.style = style
        return div
      }
      const firstTop = 34
      const perTop = 36
      const fragment = document.createDocumentFragment()
      for (let i = 0; i < cLength; i++) {
        let evenOdd = null
        evenOdd = (i & 1) === 0 ? 'ag-row-even' : 'ag-row-odd'
        const top = firstTop + i * perTop + 'px'
        const style = `top:${top}`
        fragment.appendChild(createChildRowElement(evenOdd, commonClass, style))
      }
      el.appendChild(fragment)
    },
    handlePinnedBottomRowData(newValue) {
      if (typeof this.handleDetailCount === 'function') {
        newValue.forEach((item, index) => {
          const rowNode = this.gridApi.getDetailGridInfo(`detail_${index}`)
          if (item._selectedKeys.length > 0) {
            const childSelectedList = []
            for (const childRowKey of item._selectedKeys) {
              const selectedItem = item[this.childrenListKey].find((el) => {
                return el[this.childRowKey] === childRowKey
              })
              childSelectedList.push(selectedItem)
            }
            rowNode &&
              rowNode.api.setPinnedBottomRowData([
                { _childCount: this.handleDetailCount(childSelectedList) }
              ])
          } else {
            rowNode && rowNode.api.setPinnedBottomRowData([])
          }
        })
      }
    },
    handlSelectionChange() {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedKeys = selectedNodes.map((item) => item.data[this.rowKey])
      this.rowData.forEach((item) => {
        if (selectedKeys.includes(item[this.rowKey])) {
          item._selected = true
        } else {
          item._selected = false
        }
      })
    },
    initDataSelectState(arr) {
      return arr.map((item) => {
        item._selected = false
        item._selectedKeys = []
        return item
      })
    },
    getSelectedData(func, type = null) {
      setTimeout(() => {
        const newRowData = deepClone(this.rowData)
        const filterSelectedData = newRowData
          .map((element, index) => {
            return {
              rowIndex: index + 1,
              ...element
            }
          })
          .filter((item) => {
            return (
              (item._selected ||
                (item._selectedKeys ? item._selectedKeys.length : false)) &&
              (this.childRowKey
                ? !!(
                  item[this.childrenListKey] &&
                    item[this.childrenListKey].length
                )
                : true)
            )
          })

        if (this.childRowKey) {
          // 过滤子级
          const rowData = filterSelectedData.map((item) => {
            item[this.childrenListKey] = item[this.childrenListKey].filter(
              (child) => item._selectedKeys.includes(child[this.childRowKey])
            )
            return item
          })
          // 返回子级合集
          if (type === 'margeChild') {
            return func(
              this.initDataSelectState(
                rowData.reduce((prev, next) => {
                  return prev.concat(next[this.childrenListKey])
                }, [])
              )
            )
          }
          if (type === 'delete') {
            const masterData = []
            const childData = []

            newRowData.forEach((item) => {
              if (item._selected) {
                masterData.push(item)
              } else if (
                item._selectedKeys ? item._selectedKeys.length : false
              ) {
                childData.push(item)
              }
            })

            return func({
              masterData: masterData,
              childData: childData
            })
          }

          return func(this.initDataSelectState(rowData))
        }

        func(
          this.tableSelection === 'single'
            ? this.initDataSelectState(filterSelectedData)[0]
            : this.initDataSelectState(filterSelectedData)
        )
      }, 0)
    },
    // 清空选中
    clearSelection() {
      this.rowData.forEach((item) => {
        item._selected = false
        item._selectedKeys = []
      })
      this.refreshTable()
    },
    handleGridHeight(dataLength) {
      // autoHeight=true
      // 1、高度为自适应
      // 2、没数据100
      // 3、有高度 高于15条设为高度 heightinif
      const gridHeight = this.heightinif
      if (this.autoHeight) {
        if (+dataLength === 0) {
          const headerHeight = this.headerTotal ? 34 : 0
          const footerHeight = this.footerTotal ? 32 : 0
          const paginationHeight = this.paginationinif ? 34 : 0
          this.gridHeight = 100 + headerHeight + footerHeight + paginationHeight
        } else if (+dataLength >= 15 && gridHeight) {
          this.gridHeight = gridHeight
        } else {
          this.gridHeight = 0
          this.$refs.stGrid.$el.style.height = 'auto'
          this.gridApi.setDomLayout('autoHeight')
        }
      }
    },
    // 加载表格数据 不传参数从第一页
    loadTableData(
      pagination = this.pagination
    ) {
      if (typeof this.loadData === 'function') {
        if (this.showLoading) {
          this.gridOptions.api.showLoadingOverlay()
          this.gridOptions.overlayNoRowsTemplate = `<span class="ag-overlay-loading-center">${this.$t(
            'grid.others.noData'
          )}<span>`
        }
        this.loadData(pagination)
          .then((data, heightCount) => {
            let total = 0
            if (typeof data === 'number') {
              total = data
            } else if (data && data.totalElements) {
              total = data.totalElements
            } else if (data && data.length) {
              total = data.length
            }
            if (total === 0) {
              this.gridApi.showNoRowsOverlay()
            }
            this.handleGridHeight(heightCount || total)
            this.pagination.total = total
            this.pagination.page = pagination.page
            this.pagination.limit = pagination.limit
          })
          .catch(() => {
            this.handleGridHeight(0)
            this.gridApi.showNoRowsOverlay()
            console.error(`请检查loadData`)
          })
      }
    },
    // 重新加载
    reloadTableData() {
      this.loadTableData(this.pagination)
    },
    // 刷新aggrid表格
    refreshTable() {
      this.gridApi.forEachNode((node) => {
        const detailNode = node.detailNode
        detailNode &&
          detailNode.detailGridInfo &&
          detailNode.detailGridInfo.api.refreshCells({ force: true })
      })
      this.gridApi.refreshCells({ force: true })
    },
    // 取消所有子表编辑状态
    stopChildEditing(parentId = null) {
      this.gridApi.forEachNode((node) => {
        const detailNode = node.detailNode
        if (node.id !== parentId) {
          detailNode &&
            detailNode.detailGridInfo &&
            detailNode.detailGridInfo.api.stopEditing()
        }
      })
    },
    // isAutoSizeColumnsHeader
    // isAutoSizeColumns
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.isSizeColumnsToFit) {
        this.gridApi.sizeColumnsToFit()
      }
      if (this.isAutoSizeColumns || this.isAutoSizeColumnsHeader) {
        this.handleAutoSizeColumns()
      }
      if (this.autoLoadData) {
        this.loadTableData()
      }
      this.$emit('gridReady', params)
    },
    getAutoSizeFnSkipHeaderParams() {
      const c = this.isAutoSizeColumns
      const ch = this.isAutoSizeColumnsHeader
      // 两者设置则错误提示，默认不跳过header的自适应
      if (c && ch) {
        console.error('isAutoSizeColumns与isAutoSizeColumnsHeader属性仅能设置一个')
        return false
      }
      //   isAutoSizeColumns true  and isAutoSizeColumnsHeader false  skipheader = true
      //   isAutoSizeColumns false  and isAutoSizeColumnsHeader true  skipheader = false
      return (!ch && c) ? true : !((ch && !c))
    },
    handleAutoSizeColumns() {
      const allColumnIds = []
      this.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column.getId())
      })
      // 获取 skipheader参数
      this.columnApi.autoSizeColumns(allColumnIds, this.getAutoSizeFnSkipHeaderParams()) // 是否跳过header
    },
    pageChange(pagination) {
      this.pagination.page = pagination.page
      this.pagination.limit = pagination.limit
      this.$emit('pageChange', pagination)
      this.reloadTableData(pagination)
    },
    setAgContext(key, ctx) {
      this.gridOptions.context[key] = ctx
    },
    setAgDetailContext(key, ctx) {
      this.gridOptions.detailCellRendererParams.detailGridOptions.context[key] = ctx
    }
  }
}
</script>
